<div class="preview-email-modal">
  <div class="preview-email-topo">
    <span class="preview-email-titulo">Preview do e-mail</span>
    <button type="button" class="preview-email-fechar" (click)="fechar()" title="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="preview-email-corpo">
    <div class="preview-email-remetente">
      <span class="preview-email-avatar" aria-hidden="true">
        <mat-icon>person</mat-icon>
      </span>
      <div class="preview-email-dados">
        <strong [title]="dados.remetente || 'Salve para buscar o remetente'">
          {{ dados.remetente || 'Salve para buscar o remetente' }}
        </strong>
        <span>para: Contatos Base</span>
      </div>
    </div>

    <div class="preview-email-assunto">
      <span class="preview-email-assunto-label">ASSUNTO</span>
      <strong [title]="dados.assunto || '—'">{{ dados.assunto || '—' }}</strong>
    </div>

    <div class="preview-email-frame">
      <app-email-preview [html]="dados.html"></app-email-preview>
    </div>
  </div>
</div>
